import { createContext, useContext, useReducer } from 'react';
    // let id  = 0;
    const CartContext = createContext(null);
    const CartDispatchContext = createContext(null);

    export function CartsProvider({ children }) {
        const [carts, dispatch] = useReducer(
          cartsReducer,
          initialCarts
        );

        return (
            <CartContext.Provider value={carts}>
              <CartDispatchContext.Provider value={dispatch}>
                {children}
              </CartDispatchContext.Provider>
            </CartContext.Provider>
          );
        }

    export function useCarts() {
        return useContext(CartContext);
        }

    export function useCartsQtyDispatch() {
        return useContext(CartContext);
    }

    export function useCartsDispatch() {
        return useContext(CartDispatchContext);
        }        

    function cartsReducer(carts, action) {
        switch (action.type) {
            case 'added': {
                // console.log(action,id);
                const priceNumber = parseFloat(action.price);
                const addCart = [...carts, {
                    // id: id++,
                    pdid: action.id,
                    name: action.name,
                    discount: action.discount,
                    price: priceNumber,
                    quantity: 1,
                    imageSrc: action.imageSrc,
                }];
                const totalPrice = addCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
                const cart = [{
                    subtotal: totalPrice,
                    total: totalPrice,
                    discount1:0,
                    discountrate:0,
                    vat: 0,
                    texe: 0,
                    cart: addCart,
                }]
                localStorage.setItem("cart", JSON.stringify(cart));
                return addCart;
            }
            case 'changed': {
                // console.log(action,id);
                // const priceNumber = parseFloat(action.price.replace("$", ""))
                const updatedCart = carts.map((cart) =>
                    cart.pdid === action.pdid ?
                     { ...cart, 
                        quantity: parseInt(cart.quantity) + 1,
                        // price: parseFloat(cart.price) + priceNumber,
                     } : cart
                  );   
                const totalPrice = updatedCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
                const cart = [{
                    subtotal: totalPrice,
                    total: totalPrice,
                    discount1:0,
                    discountrate:0,
                    vat: 0,
                    texe: 0,
                    cart: updatedCart,
                }]
                localStorage.setItem("cart", JSON.stringify(cart));
                  return updatedCart;             
            }
            case 'plus': {
                // console.log(action);
                // const priceNumber = parseFloat(action.price)
                const updatedCart = carts.map((cart) =>
                    cart.pdid === action.pdid ?
                     { ...cart, 
                        quantity: parseInt(cart.quantity) + 1,
                        // price: parseFloat(cart.price) + priceNumber,
                     } : cart
                  );   
                  const totalPrice = updatedCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
                  const cart = [{
                    subtotal: totalPrice,
                    total: totalPrice,
                    discount1:0,
                    discountrate:0,
                    vat: 0,
                    texe: 0,
                    cart: updatedCart,
                  }]
                  localStorage.setItem("cart", JSON.stringify(cart));
                  return updatedCart;             
            }
            case 'minus': {
                // console.log(action);
                // const priceNumber = parseFloat(action.price)
                const updatedCart = carts.map((cart) =>
                    cart.pdid === action.pdid ?
                     { ...cart, 
                        quantity: parseInt(cart.quantity) - 1 < 0 ? 0 : parseInt(cart.quantity) - 1,
                        // price: parseFloat(cart.price) - priceNumber,
                     } : cart
                  );   
                  const totalPrice = updatedCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
                  const cart = [{
                    subtotal: totalPrice,
                    total: totalPrice,
                    discount1:0,
                    discountrate:0,
                    vat: 0,
                    texe: 0,
                    cart: updatedCart,
                  }]
                  localStorage.setItem("cart", JSON.stringify(cart));
                  return updatedCart;             
            }
            case 'deleted': {
                // id--;
                // console.log(action,id);
                const updatedCart = carts.filter(t => t.pdid !== action.pdid);
                const totalPrice = updatedCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
                const cart = [{
                    subtotal: totalPrice,
                    total: totalPrice,
                    discount1:0,
                    discountrate:0,
                    vat: 0,
                    texe: 0,
                    cart: updatedCart,
                }]
                localStorage.setItem("cart", JSON.stringify(cart));
                return updatedCart;
            }
            case 'empty': {
                localStorage.removeItem("cart");
                // localStorage.removeItem("sumcart");
                return initialCarts;
            }
            default: {
                throw Error('Unknown action: ' + action.type);
            }
        }
    }

    const initialCarts = [
        // {
        //     id: 1,
        //     pdid: 1,
        //     name: 'Chocolate-Chiffon',
        //     discount: '10',
        //     price: '90.00',
        //     quantity: 1,
        //     imageSrc: 'https://craftstocrumbs.com/wp-content/uploads/2020/07/Chocolate-Chiffon-CTC-scaled.jpg',
        // },
        // {
        //     id: 2,
        //     pdid: 2,
        //     name: 'blueberry-chiffon-cake',
        //     discount: '10',
        //     price: '32.00',
        //     quantity: 1,
        //     imageSrc: 'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
        // },
    ];
